module.exports = __webpack_public_path__ + "img/d-icon-deposit.486e79a.webp";